import useCustomerSubscriptionMutations from "features/subscriptions/datahooks/useCustomerSubscriptionMutations";
import useRentalMutations from "features/subscriptions/datahooks/useRentalMutations";
import { trackSubscriptionEvent } from "features/subscriptions/utils";

import useLicenseMutations from "common/datahooks/useLicenseMutations";
import type { SubscriptionType } from "common/types";

export default function useUpdateSubscription(
  subscriptionType: SubscriptionType,
) {
  const {
    updateCustomerSubscription,
    isUpdatingCustomerSubscription,
    updateCustomerSubscriptionError,
  } = useCustomerSubscriptionMutations();

  const { addRentalAccounts, isAddingRentalAccounts, addRentalAccountsError } =
    useRentalMutations();

  const { setLicenseCount, isSettingLicenseCount, setLicenseCountError } =
    useLicenseMutations();

  async function updateSubscription({
    quantity,
    planId,
    paymentSourceId,
    accountsToCancel,
    paidAmount,
  }: {
    quantity: number;
    planId: string;
    paymentSourceId: string;
    accountsToCancel: string[];
    paidAmount: number;
  }) {
    let subscriptionId: string;
    if (subscriptionType === "user") {
      const { workspace } = await setLicenseCount({
        count: quantity,
        planId,
        accountsToCancel,
      });
      subscriptionId = workspace.subscription.id;
    } else if (subscriptionType === "agency") {
      const { subscription } = await updateCustomerSubscription({
        planPricingId: planId,
        count: quantity,
        paymentSourceId,
      });
      subscriptionId = subscription.id;
    } else {
      const { workspace } = await addRentalAccounts({
        rentalCount: quantity,
        planPriceId: planId,
      });
      subscriptionId = workspace.rental_subscription.id;
    }
    trackSubscriptionEvent("purchase", subscriptionId, paidAmount, quantity);
  }

  return {
    updateSubscription,
    isUpdatingSubscription:
      isUpdatingCustomerSubscription ||
      isAddingRentalAccounts ||
      isSettingLicenseCount,
    updateSubscriptionError:
      updateCustomerSubscriptionError ||
      addRentalAccountsError ||
      setLicenseCountError,
  };
}
